/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useState} from 'react'
import {MainLogs} from './MainLogs'
import './style.css'
import {useAuth} from '../../../modules/auth'
import {useDispatch} from 'react-redux'
import {AnyAction, ThunkDispatch} from '@reduxjs/toolkit'
import {fetchAwsRequesters} from '../../../redux/awsRequesterSlice'

type Props = {
  className: string
}

const DashboardLogs: React.FC<Props> = () => {
  const [showOndemandUI, setShowOndemandUI] = useState(true)
  const [showSheduledUI, setShowSheduledUI] = useState(false)
  const [showInPersonUI, setShowInPersonUI] = useState(false)
  const [showOperatorUI, setShowOperatorUI] = useState(false)
  const [showEffectiff, setShowEffectiff] = useState(false)
  const [callType, setCallType] = useState(1)
  const [pageTitle, setPageTitle] = useState('On Demand Log')
  const [downloadPage, setDownLoadPage] = useState('OnDemand')
  const {currentUser} = useAuth()
  const dispatch: ThunkDispatch<{}, {}, AnyAction> = useDispatch()

  function handleOndemandClick() {
    setPageTitle('On Demand Log')
    setDownLoadPage('OnDemand')
    setCallType(1)
    setShowOndemandUI(true)
    setShowSheduledUI(false)
    setShowEffectiff(false)
    setShowInPersonUI(false)
    setShowOperatorUI(false)
  }

  function handleSheduledClick() {
    setPageTitle('Scheduled Log')
    setDownLoadPage('Scheduled')
    setCallType(0)
    setShowOndemandUI(false)
    setShowSheduledUI(true)
    setShowInPersonUI(false)
    setShowEffectiff(false)
    setShowOperatorUI(false)
  }
  function handleInPersonClick() {
    setPageTitle('In Person Log')
    setDownLoadPage('InPerson')
    setCallType(2)
    setShowOndemandUI(false)
    setShowSheduledUI(false)
    setShowInPersonUI(true)
    setShowEffectiff(false)
    setShowOperatorUI(false)
  }
  function handleOperatorClick() {
    setPageTitle('Operator Log')
    setDownLoadPage('Operator')
    setCallType(3)
    setShowOndemandUI(false)
    setShowSheduledUI(false)
    setShowInPersonUI(false)
    setShowEffectiff(false)
    setShowOperatorUI(true)
  }

  function handleEffectiffClick() {
    setPageTitle('Backstop Log')
    setDownLoadPage('effectiff')
    setCallType(5)
    setShowOndemandUI(false)
    setShowSheduledUI(false)
    setShowInPersonUI(false)
    setShowOperatorUI(false)
    setShowEffectiff(true)
  }

  useEffect(() => {
    if (
      currentUser?.result?.role === 'Requester Content Admin' ||
      currentUser?.result?.userType === 'SYSTEM'
    ) {
      dispatch(fetchAwsRequesters())
    }
  }, [dispatch])

  const showMainLogs = useMemo<boolean>(() => {
    return showOndemandUI || showSheduledUI || showInPersonUI || showOperatorUI || showEffectiff
  }, [showOndemandUI, showSheduledUI, showInPersonUI, showOperatorUI, showEffectiff])

  return (
    <>
      <div className='card '>
        <div className='card-header px-0 '>
          <div className='card-toolbar'>
            <button
              type='button'
              onClick={handleOndemandClick}
              className={`btn btn-outline text-muted btn-outline-dotted btn-sm me-3 text-active-white ${
                showOndemandUI ? 'active fw-bold border border-2 bg-primary' : ''
              }`}
            >
              On Demand
            </button>
            <button
              type='button'
              onClick={handleSheduledClick}
              className={`btn btn-outline text-muted btn-outline-dotted btn-sm me-3 text-active-white me-3 ${
                showSheduledUI ? 'active fw-bold border border-2 bg-primary' : ''
              }`}
            >
              Scheduled
            </button>

          </div>
        </div>
        {showMainLogs && (
          <MainLogs callType={callType} pageTitle={pageTitle} downloadPage={downloadPage} />
        )}
      </div>
    </>
  )
}

export {DashboardLogs}
